import { Box } from '@chakra-ui/react';
import { FlexRow } from 'components/layout/FlexRow';
import { SidebarFilterToggle } from 'components/layout/SidebarLayout';
import AddressFilter from 'components/widgets/DocumentSearch/Filters/AddressFilter';
import KeywordFilter from 'components/widgets/DocumentSearch/Filters/KeywordFilter';

const rowStyle = {
  gap: 'padding_16',
  alignItems: 'end',
};

const filterContainerStyle = {
  display: 'grid',
  // Stack on phones, two-up once there's room — so the inputs never overflow
  // the viewport.
  gridTemplateColumns: {
    base: 'minmax(0, 1fr)',
    sm: 'repeat(2, minmax(0, 1fr))',
  },
  gap: 'padding_16',
  alignItems: 'end',
  flex: 1,
  minWidth: 0,
};

interface DocumentSearchFiltersProps {
  isKeywordDisabled?: boolean;
}

const DocumentSearchFilters = ({ isKeywordDisabled }: DocumentSearchFiltersProps) => {
  return (
    <FlexRow sx={rowStyle}>
      <SidebarFilterToggle />
      <Box sx={filterContainerStyle}>
        <AddressFilter />
        <KeywordFilter disabled={isKeywordDisabled} />
      </Box>
    </FlexRow>
  );
};

export default DocumentSearchFilters;
